export default class Os {
    static TYPES = {
        desktop: [
            "Fuschia",
            "Linux",
            "Windows",
            "Chrome",
            "Mac"
        ],
        mobile: [
            "Android",
            "Windows",
            "Apple"
        ],
        embeddedSystems: [
            "Adruino"
        ]
    };
}